export { default } from './CarrosEletricosBanner';
